export default __webpack_public_path__ + "static/media/illus01.f8f4ba5b.png";